/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_As_Of_No_ChangesInputs */

const en_cargos_as_of_no_changes = /** @type {(inputs: Cargos_As_Of_No_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No inventory movements were recorded on this date.`)
};

const es_cargos_as_of_no_changes = /** @type {(inputs: Cargos_As_Of_No_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se registraron movimientos de inventario en esta fecha.`)
};

/**
* | output |
* | --- |
* | "No inventory movements were recorded on this date." |
*
* @param {Cargos_As_Of_No_ChangesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_as_of_no_changes = /** @type {((inputs?: Cargos_As_Of_No_ChangesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_As_Of_No_ChangesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_as_of_no_changes(inputs)
	return es_cargos_as_of_no_changes(inputs)
});